import React, { useEffect, useCallback } from "react";
import axios from 'axios';
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import { useDropzone } from 'react-dropzone';

import Button from "components/CustomButtons/Button.js"

import defaultImage from "assets/img/image_placeholder.jpg"
import styles from 'views/component/Styles.js';
import Clearfix from "components/Clearfix/Clearfix";

const useStyles = makeStyles(styles);

export default function ImageUploader(props) {
  let { addButtonProps, saveButtonProps, changeButtonProps, removeButtonProps,
    cancelButtonProps, paramName, url, onFileUpload, prevUrl } = props;
  const classes = useStyles();

  const [file, setFile] = React.useState(null);
  const [imagePreviewUrl, setImagePreviewUrl] = React.useState(prevUrl);
  let fileInput = React.createRef();

  useEffect(() => {
    setImagePreviewUrl(prevUrl);
    setFile(null);
  }, [prevUrl])

  const handleImageChange = e => {
    e.preventDefault();
    let reader = new FileReader();
    let acceptFile = e.target.files[0];
    reader.onloadend = () => {
      setFile(acceptFile);
      setImagePreviewUrl(reader.result);
    };
    if (acceptFile) {
      reader.readAsDataURL(acceptFile);
    }
  };

  const handleSubmit = e => {
    e.preventDefault();
    let formData = new FormData();
    formData.append(paramName, file);
    axios.post(url, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
      .then(response => {
        onFileUpload(response.data);
      }).catch((error) => {
        alert(error.response.data.message);
      });
    setFile(null);
  };
  const handleClick = () => {
    fileInput.current.click();
  };
  const handleCancel = () => {
    setFile(null);
    setImagePreviewUrl(prevUrl);
    fileInput.current.value = null;
  };
  const handleRemove = () => {
    setFile(null);
    setImagePreviewUrl(defaultImage);
    fileInput.current.value = null;
  };

  const onDropRejected = useCallback(() => {
    alert('이미지 파일만 입력 가능합니다');
  }, []);

  const onDrop = function (acceptFiles) {
    if (acceptFiles.length === 1) {
      const acceptFile = acceptFiles[0];
      let reader = new FileReader();
      reader.onloadend = () => {
        setFile(acceptFile);
        setImagePreviewUrl(reader.result);
      };
      if (acceptFile) {
        reader.readAsDataURL(acceptFile);
      }
    }
  };

  const { getRootProps, getInputProps } = useDropzone({ onDrop, onDropRejected, accept: '.png,.jpg,.jpeg' });
  return (
    <div className="fileinput text-center" style={{ width: '100%', height: 'calc(100% - 100px)' }}>
      <div className={classes.right}>
        {file === null ? (
          <Button {...addButtonProps} style={{ marginBottom: 20 }} size="sm" onClick={() => handleClick()}>
            이미지 선택
          </Button>
        ) : (
            <>
              <Button {...changeButtonProps} size="sm" onClick={() => handleClick()}>
                수정
            </Button>
              <Button {...removeButtonProps} size="sm" onClick={() => handleRemove()}>
                삭제
              </Button>
              <Button {...saveButtonProps} size="sm" onClick={(e) => handleSubmit(e)}>
                저장
              </Button>
              <Button {...cancelButtonProps} style={{ marginRight: 20 }} size="sm" onClick={() => handleCancel()}>
                취소
              </Button>
            </>
          )}
      </div>
      <Clearfix />
      <input type="file" onChange={handleImageChange} ref={fileInput} />
      {imagePreviewUrl ? <>
        <img src={imagePreviewUrl} alt='이미지 미리보기'
          style={{ maxHeight: 'calc(50vh - 180px)', maxWidth: 'calc(50vw - 180px)' }} />
      </> : <>
          <div {...getRootProps({ className: 'dropzone' })} className={classes.dropzone}>
            <input {...getInputProps()} />
            <div className={classes.dropzoneText}>
              <div>파일을 드래그하여 업로드하거나<br /> 직접 입력해주세요</div>
            </div>
          </div>
        </>}
    </div>
  );
}

ImageUploader.propTypes = {
  addButtonProps: PropTypes.object,
  saveButtonProps: PropTypes.object,
  changeButtonProps: PropTypes.object,
  removeButtonProps: PropTypes.object,
  cancelButtonProps: PropTypes.object,
  paramName: PropTypes.string,
  url: PropTypes.string,
  onFileUpload: PropTypes.func,
  prevUrl: PropTypes.string
};